// import { initiateBrokerCallbackLogin } from 'common/auth/modalLogin';
// import { reactToastify } from 'v3/common/utils/reactToastify';
// import { TOASTIFY_TYPES } from 'v3/common/utils/reactToastify';

import _ from 'lodash';
import ApplicationDomain from 'v3/common/utils/applicationDomain';
import {
  supportConfig,
  navConfig,
  socialMediaConfig,
  backtestYearsCount,
  productName,
  emailAddress,
  getAddress,
} from './config';

const Default = () => {
  if (ApplicationDomain.isB2b) return null;
  const {
    SA_LOCALE: { companyName },
  } = window;

  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          {/* Logo + tagline */}
          <div className="col-lg-5">
            <img
              width={160}
              height={32}
              src={`/${_.toLower(productName)}-logo-dark.svg`}
              alt={`${productName} logo`}
            />
            <div className="padding-32 ">
              <p className="d-lg-block d-md-block d-sm-none d-xs-none d-none">
                Provides quick, no-code backtesting for {backtestYearsCount} years and automated algorithmic
                trading for both custom and pre-defined strategies
              </p>
            </div>

            {/* Social Media */}
            <div className="d-flex align-items-center">
              <ul className="d-flex align-items-center p-0 social-media-icons w-100">
                {socialMediaConfig.map((s, idx) => (
                  <li key={idx}>
                    <a
                      href={s.anchor}
                      target="blank"
                      data-track-category="Footer"
                      data-track-action={s.dataTrackAction}
                    >
                      <img src={s.iconName} alt={s.dataTrackAction} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Support Section */}
          <div className="col-lg-3 d-lg-block d-md-block d-sm-none d-xs-none d-none">
            <h2>Support</h2>
            <ul className="p-0 support-links">
              {supportConfig.map((support, idx) => (
                <li key={idx} className={support.className}>
                  <a href={support.anchor} title={support.title} target="blank">
                    {support.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="col-lg-4">
            <h2>Contact Info</h2>
            <ul className="p-0 contact-info">
              <li className="d-flex ">
                <img src="/10.svg" alt="address icon" />
                <span>
                  Address:
                  <br /> {getAddress()}
                </span>
              </li>
              <li className="d-flex d-lg-block d-md-block d-sm-none d-xs-none d-none">
                <img src="/9.svg" alt="email icon" />
                <a href={`mailto:${emailAddress}`} target="blank">
                  {emailAddress}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="gradient-line"></div>

        {/* Footer bottom */}
        <div className="footer-bottom">
          <div className="row d-flex align-items-center">
            <div className="col-lg-8 link p-0 d-lg-block d-md-block d-sm-none d-xs-none d-none">
              <ul>
                {navConfig.map((nav, idx) => (
                  <li key={idx}>
                    <a
                      className={`track flink ${nav.className}`}
                      data-track-category="Footer"
                      data-track-action={nav.dataTrackAction}
                      data-track-label="Footer track"
                      href={nav.anchor}
                      target="blank"
                      title={nav.title}
                    >
                      {nav.label} {idx !== navConfig.length - 1 && <span className="ms-1">|</span>}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-lg-4 copy-right">
              <span>© 2025 All rights reserved. {companyName}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Default;
